function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.3956 13.279L8.80863 11.8166L0 6.83691V19.7212L23.4896 33.0001V20.1158L18.7916 17.4601L17.4426 16.6975L14.0938 14.8043L11.3956 13.279Z",
  fill: "#111111"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.3951 0L0.348633 6.24472L8.63348 10.9283L11.3951 12.4894V0Z",
  fill: "#111111"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M17.442 15.9079V9.46579L23.1399 6.24472L12.0933 0V12.8843L14.2327 14.0936L17.442 15.9079Z",
  fill: "#111111"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M23.4898 19.3264V6.83691L18.1411 9.86058V16.3027L19.2108 16.9075L23.4898 19.3264Z",
  fill: "#111111"
});

function SvgBreadcrumbLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 33,
    viewBox: "0 0 24 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreadcrumbLogo);
export default __webpack_public_path__ + "static/media/breadcrumb_logo.7c3bf7a7.svg";
export { ForwardRef as ReactComponent };